import {
  AudioModelType,
  axiosInstance,
  createFilteringSortingUrlParams,
  FilteringSortingParams,
} from '../../utils';
import { UserAudio } from '../../@types';

export interface getPrivateAudiosResponse {
  data: UserAudio[];
  count: number;
}
export const getPrivateAudios = async (
  params: FilteringSortingParams,
  model?: AudioModelType,
): Promise<getPrivateAudiosResponse> => {
  const searchParams = createFilteringSortingUrlParams(params);
  if(model) {
    searchParams.append('model', model);
  }
  const res = await axiosInstance.get(`/api/audios?${searchParams.toString()}`);
  return res.data;
};
